import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";
import { LabArea } from "../external-sources/LabAreas";
import { SchemaContext } from "../../common";
import { Modes } from "./mode";
import { LinkedInstance } from "../external-sources/LinkedInstances";
import { User } from "../external-sources/Users";
import { EntryTypes } from "./entryType";

export const createLabArea = (context: SchemaContext): FieldSchema => ({
  name: "labArea",
  grid: {
    displayed: true,
    order: 74,
  },
  data: {
    variant: DataVariants.ENUM,
    options: context.labAreas.map((labArea: LabArea) => ({ value: labArea.areaName, label: labArea.areaName })),
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Lab Area",
    type: InputTypes.SELECT,
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&  
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
});
